import {
  CREATE_GENRES,
  DELETE_GENRES,
  GET_GENRES,
  UPDATE_GENRES,
} from "../../../api/endPoint";
import instance from "../../../helpers/axios";

const getGenres = () => {
  return instance.get(GET_GENRES);
};

const createGenres = (data) => {
  return instance.post(CREATE_GENRES, {
    title: data?.gneresname,
    shortdesc: data?.gneresdescription,
    titlestring: data?.gnerestitle,
  });
};

const updateGenres = (data) => {
  return instance.put(`${UPDATE_GENRES}${data?.id}`, {
    title: data?.gneresname,
    shortdesc: data?.gneresdescription || "",
    titlestring: data?.gnerestitle || "",
  });
};

const deleteGenres = (id) => {
  return instance.put(`${DELETE_GENRES}${id}`);
};

const genresService = {
  getGenres,
  createGenres,
  updateGenres,
  deleteGenres,
};

export default genresService;
